import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CreditTransitionIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12.9501 18V16.66C14.8001 16.35 15.6701 15.2 15.6701 13.83C15.6701 12.46 14.7401 11.62 12.7901 11.17V8.85999C13.4601 9.00999 13.9001 9.31999 14.2401 9.68999L15.5101 8.54999C14.9001 7.84999 14.0801 7.41999 12.9601 7.29999V5.98999H11.3701V7.29999C9.57009 7.50999 8.61009 8.47999 8.61009 9.93999C8.61009 11.29 9.46009 12.21 11.5501 12.64V15.15C10.7701 15.04 10.1201 14.66 9.59009 14.11L8.34009 15.25C9.04009 16.02 9.97009 16.59 11.3701 16.71V17.99H12.9601L12.9501 18ZM12.7901 12.93C13.5801 13.17 13.7501 13.58 13.7501 13.99C13.7501 14.52 13.4401 14.95 12.7901 15.13V12.93ZM10.5301 9.89999C10.5301 9.35999 10.8401 8.97999 11.5501 8.83999V10.9C10.8401 10.7 10.5301 10.43 10.5301 9.89999Z"
        fill={color}
      />
      <path
        d="M4.81001 4.81008C6.73001 2.89008 9.29001 1.83008 12 1.83008C13.75 1.83008 15.43 2.27008 16.92 3.10008L15.68 4.34008C15.34 4.66008 15.51 5.28008 15.96 5.39008L21.12 6.77008C21.56 6.91008 22.02 6.45008 21.89 6.00008L20.51 0.840078C20.4 0.390078 19.78 0.220078 19.46 0.560078L18.01 2.01008C16.21 0.920078 14.15 0.330078 12 0.330078C8.88001 0.330078 5.95001 1.54008 3.75001 3.75008C1.24001 6.25008 0.0200071 9.71008 0.390007 13.2401C0.480007 14.2101 2.00001 14.0401 1.88001 13.0801C1.55001 10.0001 2.62001 6.99008 4.80001 4.80008L4.81001 4.81008Z"
        fill={color}
      />
      <path
        d="M23.6099 10.7601C23.5199 9.79009 21.9999 9.95009 22.1199 10.9201C22.4499 14.0001 21.3799 17.0101 19.1999 19.2001C17.2799 21.1201 14.7199 22.1801 12.0099 22.1801C10.2599 22.1801 8.57992 21.7401 7.08992 20.9101L8.32992 19.6701C8.66992 19.3501 8.49992 18.7301 8.04992 18.6201L2.88992 17.2401C2.43992 17.1001 1.98992 17.5601 2.11992 18.0101L3.49992 23.1701C3.60992 23.6201 4.21992 23.7901 4.54992 23.4501L5.99992 22.0001C7.79992 23.0901 9.85992 23.6801 12.0099 23.6801C15.1299 23.6801 18.0599 22.4701 20.2599 20.2601C22.7699 17.7501 23.9899 14.2901 23.6099 10.7601Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CreditTransitionIcon.displayName = 'CreditTransitionIcon';
